/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';

/**
 * 
 * @export
 * @interface PharmacyDirectory
 */
export interface PharmacyDirectory {
    /**
     * 
     * @type {string}
     * @memberof PharmacyDirectory
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PharmacyDirectory
     */
    name: string;
    /**
     * 
     * @type {Address}
     * @memberof PharmacyDirectory
     */
    address: Address;
    /**
     * 
     * @type {string}
     * @memberof PharmacyDirectory
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PharmacyDirectory
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PharmacyDirectory
     */
    fax?: string;
    /**
     * OCP accreditation number — stable upsert key for OCP-sourced rows.
     * @type {string}
     * @memberof PharmacyDirectory
     */
    accreditation_number?: string;
    /**
     * Provenance — 'ocp' (from the OCP register) or 'manual' (added/kept locally).
     * @type {string}
     * @memberof PharmacyDirectory
     */
    source?: string;
}

/**
 * Check if a given object implements the PharmacyDirectory interface.
 */
export function instanceOfPharmacyDirectory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "address" in value;

    return isInstance;
}

export function PharmacyDirectoryFromJSON(json: any): PharmacyDirectory {
    return PharmacyDirectoryFromJSONTyped(json, false);
}

export function PharmacyDirectoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PharmacyDirectory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'address': AddressFromJSON(json['address']),
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'fax': !exists(json, 'fax') ? undefined : json['fax'],
        'accreditation_number': !exists(json, 'accreditation_number') ? undefined : json['accreditation_number'],
        'source': !exists(json, 'source') ? undefined : json['source'],
    };
}

export function PharmacyDirectoryToJSON(value?: PharmacyDirectory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'address': AddressToJSON(value.address),
        'phone': value.phone,
        'email': value.email,
        'fax': value.fax,
        'accreditation_number': value.accreditation_number,
        'source': value.source,
    };
}

